<template>
  <div class="home home_i api" ref="scrollContainer">
    <div class="home-header">
      <headerTop :opacity="opacity" />
      <div class="gub">
        <div class="header-font">
          <p class="header-font-p">智领未来，触手可及，共建智能生态</p>
          <p class="header-font-t">
            大模型广场，AI时代的创新引擎！赋能千行百业！
          </p>
          <p class="header-font-s">让每个创意都有AI翅膀，飞向智能新纪元！</p>
        </div>
        <!-- <div class="home-box">
          <div class="home-box-content">
            <div class="box-list">
              <div class="list-box">
                <svg
                  t="1742963768980"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2758"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientx"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M744.040284 124.508671L535.172275 6.133778a47.081166 47.081166 0 0 0-46.377189 0l-208.953339 118.396226c-7.167772 4.053204-13.119582 9.919684-17.258117 17.002125a46.142529 46.142529 0 0 0-6.314465 23.31659v235.960479a46.163862 46.163862 0 0 1-23.295258 40.254716l-209.614652 120.465494A46.291858 46.291858 0 0 0 0 601.82679v235.981812c0 8.191739 2.175931 16.212817 6.314465 23.31659 4.159867 7.082441 10.111678 12.948921 17.27945 17.002124l208.868009 118.460224c14.420874 8.085076 31.956315 8.085076 46.377188 0l209.891976-118.758881a47.017168 47.017168 0 0 1 46.441187 0l209.891976 118.737549c14.420874 8.106408 32.084311 8.106408 46.377188 0l208.868009-118.438892c7.189104-4.053204 13.140914-9.919684 17.300782-17.002124 4.159867-7.082441 6.357131-15.146184 6.357131-23.31659V601.82679a46.291858 46.291858 0 0 0-23.359255-40.254717l-209.614652-120.529491a46.163862 46.163862 0 0 1-23.380588-40.254717V164.763388a46.163862 46.163862 0 0 0-23.572582-40.318715v0.063998z m-181.967533 158.565613v246.733468l213.923847 122.662757a17.386112 17.386112 0 0 1 8.575727 17.36478 17.279449 17.279449 0 0 1-2.218596 6.421129l-28.500425 49.065102a17.45011 17.45011 0 0 1-17.471443 8.533062 17.556774 17.556774 0 0 1-6.463794-2.175931l-214.222505-122.876083-214.201172 122.812085a17.514108 17.514108 0 0 1-23.95657-6.378463l-28.479092-49.065103a17.300782 17.300782 0 0 1 6.335798-23.764576l214.649158-123.046744V283.010286c0-9.663692 7.786418-17.492776 17.45011-17.492776h57.043516c9.685025 0 17.535441 7.893082 17.535441 17.492776v0.063998z"
                    fill="url(#gradientx)"
                    p-id="2759"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">模型托管数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">模型部署数量</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965679316"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2937"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxl"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M988.821333 353.749333l-148.629333 148.693334a120.085333 120.085333 0 0 1-169.834667 0l-148.650666-148.693334a120.149333 120.149333 0 0 1 0-169.898666l148.650666-148.672a120.106667 120.106667 0 0 1 169.813334 0l148.650666 148.693333a120.149333 120.149333 0 0 1 0 169.877333z m-658.410666 140.202667H120.021333A120.106667 120.106667 0 0 1 0 373.888V163.712a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.170667 120.170667 0 0 1 120.277333 120.064v210.154667a120.170667 120.170667 0 0 1-120.021333 120.32zM860.330667 1024h-210.133334a120.106667 120.106667 0 0 1-120.021333-120.064v-210.154667a120.106667 120.106667 0 0 1 120.042667-120.064h210.112a120.106667 120.106667 0 0 1 120.021333 120.064v210.154667A120.106667 120.106667 0 0 1 860.330667 1024z m-529.92 0H120.021333A120.106667 120.106667 0 0 1 0 903.936v-210.154667a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.106667 120.106667 0 0 1 120.021333 120.042667v210.176a119.893333 119.893333 0 0 1-73.813333 111.146667 119.765333 119.765333 0 0 1-45.952 9.173333z"
                    fill="url(#gradientxl)"
                    p-id="2938"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">占用加速卡</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965790260"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3116"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxa"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M326.4 462.933333h-17.066667v108.8l8.533334 2.133334h8.533333c14.933333 0 25.6-4.266667 34.133333-12.8 8.533333-8.533333 12.8-23.466667 12.8-40.533334 0-19.2-4.266667-32-12.8-42.666666-8.533333-10.666667-19.2-14.933333-34.133333-14.933334z"
                    p-id="3117"
                    fill="url(#gradientxa)"
                  ></path>
                  <path
                    d="M985.6 558.933333c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333h-100.266667v-123.733334h108.8c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333H874.666667c-4.266667-29.866667-19.2-59.733333-40.533334-81.066667s-51.2-38.4-81.066666-42.666667V66.133333c0-10.666667-4.266667-21.333333-12.8-29.866666-8.533333-8.533333-19.2-12.8-29.866667-12.8s-21.333333 4.266667-29.866667 12.8c-8.533333 8.533333-12.8 19.2-12.8 29.866666V149.333333h-123.733333V57.6c-2.133333-12.8-8.533333-23.466667-19.2-32-6.4-4.266667-14.933333-6.4-21.333333-6.4-8.533333 0-14.933333 2.133333-21.333334 6.4-6.4 4.266667-12.8 10.666667-14.933333 17.066667-4.266667 6.4-4.266667 14.933333-4.266667 21.333333v85.333333H341.333333V57.6c0-10.666667-6.4-21.333333-14.933333-27.733333s-17.066667-8.533333-29.866667-8.533334c-10.666667 0-21.333333 6.4-27.733333 14.933334-6.4 8.533333-10.666667 19.2-8.533333 29.866666V149.333333c-32 4.266667-61.866667 21.333333-85.333334 44.8-21.333333 23.466667-36.266667 55.466667-38.4 87.466667H36.266667c-10.666667 2.133333-21.333333 6.4-27.733334 14.933333-4.266667 8.533333-8.533333 19.2-8.533333 29.866667 0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 10.666667h91.733333v123.733333H36.266667c-10.666667 0-21.333333 6.4-27.733334 14.933334s-8.533333 17.066667-8.533333 27.733333 6.4 21.333333 14.933333 27.733333c8.533333 6.4 19.2 10.666667 29.866667 8.533334h91.733333v123.733333H44.8c-10.666667 0-21.333333 4.266667-29.866667 12.8-8.533333 8.533333-12.8 19.2-12.8 29.866667s4.266667 21.333333 12.8 29.866666c8.533333 8.533333 19.2 12.8 29.866667 12.8h96c6.4 27.733333 21.333333 55.466667 42.666667 74.666667 21.333333 19.2 49.066667 32 76.8 36.266667v91.733333c2.133333 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334 6.4-8.533333 10.666667-19.2 10.666667-29.866666v-81.066667h123.733333v89.6c0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334s10.666667-19.2 8.533334-29.866666v-81.066667h121.6v81.066667c0 10.666667 4.266667 21.333333 12.8 29.866666 8.533333 8.533333 19.2 12.8 29.866666 12.8 10.666667 0 21.333333-4.266667 29.866667-12.8 8.533333-8.533333 12.8-19.2 12.8-29.866666v-83.2c29.866667-4.266667 59.733333-19.2 81.066667-40.533334 21.333333-21.333333 36.266667-51.2 40.533333-81.066666H981.333333c10.666667 0 19.2-6.4 25.6-12.8 6.4-8.533333 10.666667-17.066667 10.666667-27.733334s-4.266667-19.2-10.666667-27.733333-17.066667-12.8-25.6-12.8h-100.266666v-123.733333h104.533333z m-563.2 2.133334c-4.266667 12.8-12.8 23.466667-21.333333 32-8.533333 8.533333-21.333333 14.933333-34.133334 19.2-12.8 4.266667-27.733333 6.4-42.666666 6.4h-12.8l-12.8-4.266667-14.933334-2.133333c-4.266667 0-8.533333-2.133333-12.8-4.266667-10.666667-4.266667-17.066667-12.8-17.066666-23.466667v-145.066666-6.4c0-2.133333 2.133333-4.266667 2.133333-4.266667 2.133333-2.133333 6.4-4.266667 10.666667-6.4 8.533333-2.133333 19.2-4.266667 27.733333-6.4 10.666667 0 19.2-2.133333 27.733333-2.133333 17.066667 0 29.866667 2.133333 44.8 6.4 12.8 4.266667 23.466667 10.666667 34.133334 19.2 8.533333 8.533333 17.066667 19.2 21.333333 29.866666 4.266667 12.8 8.533333 27.733333 8.533333 44.8 0 19.2-4.266667 34.133333-8.533333 46.933334z m166.4 38.4c-2.133333 4.266667-6.4 6.4-12.8 10.666666-4.266667 2.133333-8.533333 4.266667-14.933333 4.266667-6.4 2.133333-14.933333 2.133333-25.6 2.133333-14.933333 0-27.733333-2.133333-40.533334-6.4-12.8-4.266667-23.466667-10.666667-32-17.066666-8.533333-8.533333-17.066667-19.2-21.333333-32-4.266667-12.8-8.533333-27.733333-8.533333-44.8s2.133333-29.866667 8.533333-42.666667c4.266667-12.8 12.8-23.466667 21.333333-32 8.533333-8.533333 19.2-14.933333 32-19.2 12.8-4.266667 25.6-6.4 38.4-6.4 19.2 0 34.133333 2.133333 44.8 8.533333 10.666667 6.4 14.933333 14.933333 14.933334 23.466667 0 6.4-2.133333 10.666667-4.266667 14.933333-2.133333 4.266667-6.4 6.4-8.533333 8.533334-6.4-4.266667-10.666667-6.4-17.066667-8.533334-6.4-2.133333-14.933333-4.266667-21.333333-4.266666-14.933333 0-27.733333 4.266667-36.266667 14.933333-8.533333 10.666667-12.8 23.466667-12.8 40.533333 0 19.2 4.266667 32 12.8 42.666667 8.533333 8.533333 21.333333 14.933333 38.4 14.933333 8.533333 0 14.933333-2.133333 21.333333-4.266666 6.4-2.133333 10.666667-4.266667 17.066667-8.533334 4.266667 2.133333 6.4 6.4 8.533333 10.666667 2.133333 4.266667 2.133333 8.533333 2.133334 14.933333-2.133333 6.4-2.133333 12.8-4.266667 14.933334z m181.333333-55.466667c0 10.666667-2.133333 21.333333-6.4 29.866667-4.266667 8.533333-8.533333 17.066667-17.066666 23.466666-8.533333 6.4-17.066667 12.8-25.6 14.933334-10.666667 4.266667-23.466667 6.4-34.133334 4.266666-12.8 0-23.466667-2.133333-34.133333-4.266666s-19.2-8.533333-25.6-14.933334c-6.4-6.4-12.8-14.933333-17.066667-23.466666-4.266667-10.666667-6.4-19.2-6.4-29.866667v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133333 10.666667 0 17.066667 2.133333 21.333334 4.266666 4.266667 4.266667 6.4 10.666667 6.4 21.333334v96c0 10.666667 2.133333 17.066667 8.533333 23.466666 6.4 6.4 12.8 8.533333 21.333333 8.533334 4.266667 0 8.533333 0 10.666667-2.133334 4.266667-2.133333 6.4-4.266667 10.666667-6.4 6.4-6.4 8.533333-12.8 8.533333-23.466666v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133334 10.666667 0 17.066667 2.133333 23.466667 4.266667 4.266667 4.266667 6.4 10.666667 6.4 21.333333v100.266667z"
                    p-id="3118"
                    fill="url(#gradientxa)"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >30%</span
                  >
                  <span style="font-size: 0.85rem">系统负载</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965994399"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3296"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxc"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M755.413333 579.989333A391.232 391.232 0 0 0 513.92 981.333333H42.666667c0-259.2 210.133333-469.333333 469.333333-469.333333 89.130667 0 172.437333 24.832 243.413333 67.989333zM512 512c-129.6 0-234.666667-105.066667-234.666667-234.666667S382.4 42.666667 512 42.666667s234.666667 105.066667 234.666667 234.666666-105.066667 234.666667-234.666667 234.666667z m195.541333 156.458667H981.333333V746.666667H707.541333v-78.208z m-78.208 117.333333H981.333333V864H629.333333v-78.208z m-39.125333 117.333333H981.333333V981.333333H590.208v-78.208z"
                    fill="url(#gradientxc)"
                    p-id="3297"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >124</span
                  >

                  <span style="font-size: 0.85rem">在线用户</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="box-content-tab">
          <div class="content-tab-top">
            <div class="content-tab-left">
              <span class="tab-left-line"></span>
              <span>查询条件</span>
            </div>
            <el-divider></el-divider>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px;
                padding-left: 30px;
                color: #333;
                font-szie: 0.85rem;
              "
            >
              <div>
                <span class="label">密钥描述：</span
                ><el-input
                  v-model="intro"
                  placeholder="请输入密钥描述"
                  style="width: 200px"
                  size="small"
                  @blur="init"
                  @keyup.enter.native="init('click')"
                ></el-input>
              </div>

              <!-- <div>
                <span class="label">创建时间：</span
                ><el-select v-model="craedtime" placeholder="请选择" size="small" @change="init">
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div> -->
              <div>
                <span class="label">密钥有效期：</span
                ><el-select
                  v-model="exp"
                  placeholder="请选择"
                  size="small"
                  @change="init('click')"
                >
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <span class="label">状态：</span
                ><el-select
                  v-model="state"
                  placeholder="请选择"
                  size="small"
                  @change="init('click')"
                >
                  <el-option label="启用" value="启用"> </el-option>
                  <el-option label="禁用" value="禁用"> </el-option>
                </el-select>
              </div>
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="init('click')"
                  >查询</el-button
                >
                <el-button
                  size="mini"
                  style="margin-left: 5px"
                  icon="el-icon-refresh-left"
                  @click="reset"
                  >重置</el-button
                >
              </div>
            </div>
          </div>
          <div class="content-tab-bottom">
            <div class="content-tab-left">
              <span class="tab-left-line"></span>
              <span>查询结果</span>
              <div class="content-tab-right">
                <el-button
                  type="success"
                  icon="el-icon-circle-plus-outline"
                  size="mini"
                  @click="addKey"
                  >新建密钥</el-button
                >
                <!-- <el-button icon="el-icon-delete" size="mini"
                  >批量删除</el-button
                > -->
              </div>
            </div>
            <el-divider></el-divider>
            <div style="padding: 10px">
              <el-table
                border
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                class="custom-table"
              >
                <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                <el-table-column type="index" width="55" label="序号">
                </el-table-column>
                <el-table-column label="密钥(点击可复制)" prop="title">
                  <template slot-scope="scope">
                    <div class="copy-key" @click="copyKey(scope.row.title)">
                      {{ scope.row.title }}
                      <i class="el-icon-document-copy copy-icon"></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="intro" label="密钥描述">
                </el-table-column>
                <el-table-column
                  prop="_sys_createtime"
                  label="创建时间"
                  show-overflow-tooltip
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="exptime"
                  label="过期时间"
                  show-overflow-tooltip
                  width="200"
                >
                </el-table-column>
                <el-table-column
                  prop="exp"
                  label="密钥有效期"
                  show-overflow-tooltip
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="state"
                  label="状态"
                  show-overflow-tooltip
                  width="100"
                >
                  <template slot-scope="scope">
                    <el-switch
                      @change="changeState(scope.row)"
                      v-model="scope.row.state == '启用' ? true : false"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="edit(scope.row)"
                      type="text"
                      size="small"
                    >
                      编辑
                    </el-button>
                    <el-button
                      @click.native.prevent="deleteRow(scope.row)"
                      type="text"
                      size="small"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px; text-align: right">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 15, 20, 25, 30]"
                  :page-size="limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-backtop target=".home" :bottom="100" :right="40" class="custom-backtop">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="90px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="标题" prop="title">
    <el-input v-model="ruleForm.title"></el-input>
  </el-form-item> -->
        <el-form-item label="有效期(天)" prop="exp">
          <el-input-number
            v-model="ruleForm.exp"
            :min="1"
            :max="9999"
            label="描述文字"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="introname" prop="intro">
          <el-input
            type="textarea"
            :rows="2"
            v-model="ruleForm.intro"
            :placeholder='this.introname=="业务名称" ? "只能输入英文且最多输入16个英文字符" : ""'
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import headerTop from "@/components/headerTop.vue";

export default {
  name: "Home",
  components: {
    headerTop,
  },
  data() {
    return {
      introname: "描述",
      intro: "",
      craedtime: "",
      exp: "",
      title: "新建密钥",
      state: "",
      dialogVisible: false,
      input: "",
      value: "",
      isFixed: false,
      tabTop: 300, // 固定位置阈值
      opacity: false,
      currentPage: 1,
      limit: 10,
      total: 0,
      options: ["2个月内", "3个月内", "6个月内", "一年内"],
      tableData: [],
      multipleSelection: [],
      ruleForm: {
        // title:'',
        exp: "",
        intro: "",
      },
      rules: {
        // title: [
        //   { required: true, message: "请输入标题", trigger: "blur" },
        // ],
        exp: [{ required: true, message: "请输入有效期", trigger: "blur" }],
        intro: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
    };
  },
  mounted() {
    const isAdmin = localStorage.getItem("anjing_name_group") === "admin";

    // 1. 设置标题
    this.introname = isAdmin ? "业务名称" : "描述";

    // 2. 动态设置提示文字
    this.rules.intro[0].message = isAdmin ? "请输入业务名称" : "请输入描述";

    // 3. 管理员 → 加16字限制；普通用户 → 不加
    if (isAdmin) {
      this.rules.intro.push({
        max: 16,
        message: "业务名称只能输入英文且最多输入16个英文字符",
        trigger: "blur",
      }); // 新增：强制校验只能输入英文字符（大小写）
      this.rules.intro.push({
        pattern: /^[a-zA-Z]+$/, // 正则：仅允许大小写英文字母
        message: "业务名称只能输入英文且最多输入16个英文字符",
        trigger: "blur", // 失去焦点时校验，也可加 'change' 实时校验
      });
    }
    // 获取滚动容器（height:calc(100vh - 60px) 的 div）
    const scrollContainer = this.$refs.scrollContainer;

    scrollContainer.addEventListener("scroll", this.handleScroll);
    this.init();
  },
  beforeDestroy() {
    const scrollContainer = this.$refs.scrollContainer;
    scrollContainer.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //   copyKey(text) {
    //   navigator.clipboard.writeText(text)
    //     .then(() => {
    //       this.$message.success('复制成功');
    //     })
    //     .catch(err => {
    //       console.error('复制失败:', err);
    //       this.$message.error('复制失败，请手动复制');
    //     });
    // },
    async copyKey(text) {
      try {
        // 现代浏览器方案
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
          this.$message.success("复制成功");
          return;
        }

        // 兼容旧浏览器的隐藏textarea方案
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed"; // 避免触发滚动
        document.body.appendChild(textarea);
        textarea.select();

        // 执行复制命令
        const success = document.execCommand("copy");
        console.log("success", success);
        if (success) {
          this.$message.success("复制成功");
        } else {
          throw new Error("复制失败");
        }

        document.body.removeChild(textarea);
      } catch (err) {
        console.error("复制失败:", err);
        this.$message.error(`复制失败: ${err.message}`);
      }
    },
    deleteRow(obj) {
      this.$confirm("确定删除该数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let data = {
            op: "key_del",
            _id: obj._id,
          };

          let _this = this;
          this.$axios
            .post("/index.do", _this.Qs.stringify(data), {
              headers: {
                Authorization:
                  window.localStorage.getItem("anjing_name_token") || "",
              },
            })
            .then(function (response) {
              console.log(response);
              if (response.data.value == "ok") {
                _this.init();
              } else {
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleScroll(e) {
      // 滚动到底部判断（距离底部50px时触发）
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      this.isFixed = scrollTop >= this.tabTop;
      // if (scrollHeight - scrollTop - clientHeight < 50) {
      //   this.loadMoreCourses()
      // }
      if (scrollTop > 38) {
        this.opacity = true;
      } else {
        this.opacity = false;
      }
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.init();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addKey() {
      this.dialogVisible = true;
      (this.id = ""), (this.title = "新建密钥");
    },
    edit(obj) {
      this.dialogVisible = true;
      this.id = obj._id;
      this.title = "编辑";
      this.ruleForm.exp = obj.exp;
      this.ruleForm.intro = obj.intro;
    },
    changeState(obj) {
      let data = {
        op: "key_set",
        _id: obj._id,
        type: obj.state == "启用" ? "close" : "open",
      };

      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.init();
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            op: "key_add",
            // title: this.ruleForm.title,
            exp: this.ruleForm.exp,
            intro: this.ruleForm.intro,
          };
          if (this.title == "编辑") {
            data.op = "key_edit";
            data._id = this.id;
          }

          let _this = this;
          this.$axios
            .post("/index.do", _this.Qs.stringify(data), {
              headers: {
                Authorization:
                  window.localStorage.getItem("anjing_name_token") || "",
              },
            })
            .then(function (response) {
              console.log(response);
              if (response.data.value == "ok") {
                _this.dialogVisible = false;
                _this.init();
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error",
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              this.dialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    goManage() {
      console.log(90);
      let data = {
        op: "login",
      };

      let _this = this;
      this.$axios
        .post("/auth/authcontrol.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            window.location.href = response.data.data;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    reset() {
      this.state = "";
      this.intro = "";
      this.exp = "";
      this.currentPage = 1;
      this.limit = 10;
      this.init();
    },
    init(type = "") {
      console.log(90);
      if (type == "click") {
        this.currentPage == 1;
      }
      let data = {
        op: "key_search",
        page: this.currentPage,
        limit: this.limit,
        state: this.state,
        intro: this.intro,
        exp: this.exp,
      };
      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.tableData = response.data.data;
            _this.total = response.data.count;
            // _this.all = response.data.all;
          }
          if (response.data.value == "login_error") {
            //未登录
            _this.$message({
              message: response.data.msg,
              type: "info",
            });
            setTimeout(() => {
              _this.goManage();
            }, 1000);
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.home {
  height: 100vh;
  background: #f5f5f5;
  overflow: auto;
}
.home-header {
  background: url("../image/banner.png");
  width: 100vw;
  height: 35vh;
  background-size: cover;
}
.home-box {
  /* padding-top: 8vh; */
}
.home-box-content {
  /* height: 90px; */
  background: #fff;
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
}
.box-list {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.list-box {
  display: flex;
}
.list-box-content {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: 20px;
  color: #666;
  /* border-right:1px solid #E0E0E0 ; */
}
.list-box svg {
  margin-top: 6px;
}
.header-font {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding-top: 11vh;
  height: 24vh;

  color: #333;
}
.box-content-tab {
  position: relative;
  margin-top: 15px;
  min-width: 1200px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: left;
}
.content-tab-top {
  background: #fff;
}
.content-tab-left {
  padding: 15px;
  color: #333;
  font-size: 0.85rem;
  font-weight: bold;
}
.tab-left-line {
  float: left;
  width: 3px;
  height: 16px;
  margin-top: 2px;
  background: #4384f4;
  margin-right: 10px;
}
.content-tab-top .label {
  font-size: 0.85rem;
  font-weight: bold;
}
.content-tab-bottom {
  background: #fff;
  margin-top: 10px;
}
.content-tab-right {
  float: right;
  margin-top: -5px;
}
.copy-key {
  cursor: pointer;
  color: #409eff;
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

.copy-key:hover {
  color: #67c23a;
}

.copy-icon {
  margin-left: 5px;
  font-size: 14px;
}
/* 自定义表头样式 */
::v-deep .custom-table th {
  background-color: #f1f5f9; /* 背景色 */
  color: #333333 !important; /* 文字颜色 */
  font-weight: 500; /* 字体粗细 */
}

/* 表头边框调整 */
::v-deep .custom-table thead th {
  border-right: 1px solid #ddd;
}
.home_i /deep/.el-input__inner {
  border-radius: 2px;
}
</style>
<style >
.home-box-content .el-divider--vertical {
  height: 3rem;
  position: static;
}
.api .el-divider--horizontal {
  margin: 0;
}

.home_i .el-tag--mini {
  margin-right: 5px;
  color: #4384f4;
  background: #e6f0ff;
  border-color: #e6f0ff;
}
.home_i .el-tag.el-tag--info {
  border-color: #f4f4f4;
}
.box-card .el-divider--horizontal {
  margin-bottom: 10px;
  margin-top: 15px;
}
.box-card .el-divider--vertical {
  height: 1.5em;
}
.content-tab-left .el-divider--horizontal {
  margin: 0;
}
.content-tab-top .el-button--primary {
  background-color: #4384f4;
  border-color: #4384f4;
}
.content-tab-bottom .el-button--success {
  background-color: #05bab4;
  border-color: #05bab4;
}
.api .el-input-number {
  width: 100%;
}
</style>

